webpackJsonp([70326357482022],{

/***/ 359:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Anatomy = __webpack_require__(10);
	
	var _Anatomy2 = _interopRequireDefault(_Anatomy);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Anatomy2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'postcss.config.js'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This is a configuration file for ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://github.com/postcss/postcss' },
	        'postcss'
	      ),
	      ', a webpack loader for transforming styles using JS plugins.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Plugins can be used to lint your CSS, automatically include vendor prefixes, add support for variables and mixins, transpile future CSS syntax, inline images, and more.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'To learn more about this file, see the ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://github.com/michael-ciniawsky/postcss-load-config' },
	        'postcss config documentation'
	      ),
	      ' on GitHub.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'By default, new projects include the ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://github.com/postcss/autoprefixer' },
	        'autoprefixer plugin'
	      ),
	      ', which automatically adds vendors prefixes to any CSS properties (which includes any code written in LESS or SASS).'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Defaults'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The default file included in new projects looks like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      module.exports = {\n        plugins: [\n          require(\'autoprefixer\')({\n            /* ...options... */\n          })\n        ]\n      };\n      ' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-anatomy-postcss-config-js-8e938cc2207837aea0f8.js